import {Component, ElementRef, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {DecimalPipe} from '@angular/common';
import {GebaeudeStepComponent} from '../gebaeude/gebaeude.step.component';
import {PortalService} from '../../services/portal.service';
import {MatDialog} from '@angular/material/dialog';
import {UntypedFormGroup} from "@angular/forms";
import {StancheckAnfrage} from "../anfrage/stancheck.anfrage";
import {StancheckRequestService} from "../services/request.service";
import {StancheckBackendService} from "../services/backend.service";
import {ChartData, TooltipItem} from 'chart.js';
import {AppTranslatePipe} from "../../pipe/AppTranslatePipe";
import {ChartOptions} from "chart.js";
import {BaseChartDirective} from "ng2-charts";

/**
 *
 */
@Component({
    selector: 'app-stancheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends GebaeudeStepComponent implements OnInit {

  /**
   * get Stromcheckanfrage
   */
  anfrage: StancheckAnfrage;

  /**
   * form for validation
   */
  form: UntypedFormGroup;

  /**
   * textkey prefix
   */
  textkeyPrefix: string = "stancheck.ergebnis";

  /**
   * data for the dialog registration
   */
  dialogData: any = {};

  /**
   * current portalId
   */
  portalId: string;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * URL for the report to download
   */
  reportUrl: string;

  /**
   * Event emitter activated every time when class changes after car electricity input
   */
  classHasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * indicator if there is a result available or not.
   */
  hasResult: boolean = true;

  /**
   * The resultWrapper element
   */
  @ViewChild('resultWrapper') resultWrapper: ElementRef;

  @ViewChild('compareChart') compareChart: BaseChartDirective;

  @ViewChild('categoriesChart') categoriesChart: BaseChartDirective;

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  compareChartData: ChartData<"bar", number[], string> = {
    datasets: [],
    labels: [],
  };

  compareChartOptions: ChartOptions<"bar"> = {
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: ''
        },
      },
    },
    plugins: {
      colors: {
        enabled: true
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<"bar">) => {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed === null || context.parsed.y === null) {
              return label;
            }
            return label + this.decimalPipe.transform(context.parsed.y, '1.0-0') + ' kWh';
          }
        }
      }
    }
  };

  categoriesChartData: ChartData<"bar", number[], string> = {
    labels: [],
    datasets: []
  };

  categoriesChartOptions: ChartOptions<"bar"> = {
    indexAxis: 'y',
    scales: {
      x: {
        stacked: false,
        title: {
          display: true,
          text: ''
        },
      },
      y: {
        stacked: false,
      },
    },
    plugins: {
      colors: {
        enabled: true
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<"bar">) => {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed === null || context.parsed.x === null) {
              return label;
            }
            return label + this.decimalPipe.transform(context.parsed.x, '1.0-0') + ' kWh';
          }
        }
      }
    }
  };

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: StancheckRequestService,
              protected elementService: ElementService, public element: ElementRef, protected portalService: PortalService,
              public dialog: MatDialog, protected backendService: StancheckBackendService, private decimalPipe: DecimalPipe,
              protected translate: AppTranslatePipe) {
    super(stepService, router, requestService, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();
    this.anfrage = this.requestService.getAnfrage();
    console.log(this.anfrage.userInput, this.anfrage.result);

    if(!this.anfrage.result || Object.keys(this.anfrage.result).length === 0) {
      // There is no result available. Maybe a reload and no third party cookies. Show error message.
      this.hasResult = false;
    }

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();
    this.initCharts();
  }

  private async initCharts() {
    while (this.translate.transform(this.textkeyPrefix) === '') {
      await new Promise(f => setTimeout(f, 30));
    }
    this.calculateCompareChartData();
    this.calculateCategoriesChartData();
  }

  private calculateCategoriesChartData() {
    const result = this.anfrage?.result;
    if (result === null) {
      return;
    }
    this.categoriesChartOptions.scales.x.title.text = this.translate.transform(this.textkeyPrefix + '.chart.y_achse');
    this.categoriesChartData.labels = [
      this.translate.transform(this.textkeyPrefix + '.chart.waschen'),
      this.translate.transform(this.textkeyPrefix + '.chart.kuehlen'),
      this.translate.transform(this.textkeyPrefix + '.chart.kochen'),
      this.translate.transform(this.textkeyPrefix + '.chart.unterhaltung'),
      this.translate.transform(this.textkeyPrefix + '.chart.beleuchtung'),
    ];
    this.categoriesChartData.datasets = [
      {
        label: this.translate.transform(this.textkeyPrefix + '.chart.eigener_haushalt'),
        backgroundColor: '#156081',
        data: [
          result.self.ws,
          result.self.kg,
          result.self.kb,
          result.self.ue,
          result.self.lighting,
        ]
      },
      {
        label: this.translate.transform(this.textkeyPrefix + '.chart.durchschnitt'),
        backgroundColor: '#d8d8d8',
        data: [
          result.compare.ws,
          result.compare.kg,
          result.compare.kb,
          result.compare.ue,
          result.compare.lighting,
        ]
      },
    ];
    if (this.categoriesChart) {
      this.categoriesChart.update();
    }
  }

  private calculateCompareChartData() {
    const result = this.anfrage?.result;
    if (result === null) {
      return;
    }
    this.compareChartOptions.scales.y.title.text = this.translate.transform(this.textkeyPrefix + '.chart.y_achse');
    const showMeasurement = this.anfrage.result.rating_caluclation !== 'equal';
    this.compareChartData.labels = [];
    this.compareChartData.labels.push(this.translate.transform(this.textkeyPrefix + '.chart.eigener_haushalt'));
    this.compareChartData.labels.push(this.translate.transform(this.textkeyPrefix + '.chart.durchschnitt'));

    const datasets = [];
    if (result.self.pv) {
      datasets.push({
        backgroundColor: 'rgba(253,191,1,0.5)',
        borderColor: '#fdbf01',
        pointStyle: false,
        stack: 0,
        label: this.translate.transform(this.textkeyPrefix + '.chart.pv_eigenstrom'),
        data:  [result.self.pv, 0]
      });
    }
    if (result.self.net_household && showMeasurement) {
      datasets.push({
        type: 'line',
        backgroundColor: '#e87132',
        borderColor: '#e87132',
        label: this.translate.transform(this.textkeyPrefix + '.chart.stromrechnung'),
        data: [result.self.net_household, result.self.net_household],
      });
    }
    if (result.self.calculated) {
      datasets.push({
        backgroundColor: '#156081',
        stack: 1,
        label: this.translate.transform(this.textkeyPrefix + '.chart.errechnet'),
        data: [result.self.calculated, 0],
      });
    }
    if (result.self.net_household && showMeasurement && result.self.calculated && result.self.net_household > result.self.calculated) {
      datasets.push({
        backgroundColor: '#89d4ff',
        pointStyle: false,
        stack: 1,
        label: this.translate.transform(this.textkeyPrefix + '.chart.stromrechnung_differenz'),
        data: [result.self.net_household - result.self.calculated, 0]
      });
    }
    if (result.compare.net_household) {
      datasets.push({
        backgroundColor: '#d8d8d8',
        grouped: false,
        label: this.translate.transform(this.textkeyPrefix + '.chart.durchschnitt_saeule'),
        data: [0, result.compare.net_household],
      });
    }
    this.compareChartData.datasets = datasets;
    if (this.compareChart) {
      this.compareChart.update();
    }
  }
}
